<div class="sm-flex sm-flex-col sm-gap-2">
  <div class="sm-flex sm-items-center">
    <span class="sm-text-secondary-text">Select file from your computer</span>
    <button
      #chooseFiles
      type="button"
      class="btn btn-success sm-ml-auto"
      [disabled]="maxFilesReached"
      data-test="choose-file-button"
    >
      Choose File
    </button>
  </div>

  <div
    #droppableArea
    class="dropzone-area dropzone-container sm-w-full sm-flex"
    [class.sm-justify-center]="!fileSelected"
  >
    <div class="dz-message placeholder sm-flex sm-flex-col sm-justify-center sm-items-center">
      <i class="mb-3 cc-icon cc-icon-plus sm-text-grey-5" aria-hidden="true"></i>
      <div i18n class="sm-text-grey-5">Drag'n drop files here to upload</div>
    </div>
  </div>
</div>
